// extracted by mini-css-extract-plugin
export default {"frame":"SearchFormText_frame__tr2EV","bigText":"SearchFormText_bigText__zEzvr","smallText":"SearchFormText_smallText__txNTL"};